import { useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useGetWorkTimes2Query } from "../../../api/plamo-api";

dayjs.extend(utc)


const SingleWorkTimeLoader = ({ employeeId, monthKey, addWorkTimes, removeWorkTimes }: any) => {
  const begin = dayjs(monthKey.replace('/', '-') + '-01T00:00:00')
  const end = begin.add(1, 'months')
  const { data: workTimes } = useGetWorkTimes2Query({
    o: 0,
    c: 1000,
    f: JSON.stringify({
      "employeeId": { c: "EQ", v: employeeId },
      "changeRequestForId": { c: "EQ", v: null },
      "startTime": {
        c: "BTW",
        v: begin.utc().format('YYYY-MM-DDTHH:mm:ss') + '.000',
        v2: end.utc().format('YYYY-MM-DDTHH:mm:ss') + '.000',
        t: "DATE"
      }
    })
  }) as any;

  useEffect(() => {
    if(workTimes?.items?.length) {
      addWorkTimes(monthKey, workTimes.items);

      return () => removeWorkTimes(monthKey);
    }
  }, [workTimes, monthKey, addWorkTimes, removeWorkTimes])

  return <></>
}

const WorkTimesLoader = ({ months, onWorkTimesLoaded, employeeId }: any) => {
  const [workTimes, setWorkTimes] = useState<any>({})

  const addWorkTimes = useCallback((monthKey: string, items: any) => {
    setWorkTimes(existing => ({...existing, [monthKey]: items}));
  }, [setWorkTimes])

  const removeWorkTimes = useCallback((monthKey: any) => {
    setWorkTimes(existing => ({...existing, [monthKey]: undefined}));
  }, [setWorkTimes]);

  useEffect(() => {
    onWorkTimesLoaded(workTimes);
  }, [workTimes, onWorkTimesLoaded])

  return <>
  {
    months.map((monthKey: string) => <SingleWorkTimeLoader key={monthKey} monthKey={monthKey} addWorkTimes={addWorkTimes} removeWorkTimes={removeWorkTimes} employeeId={employeeId} />)
  }
  </>
}

export default WorkTimesLoader;
